/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Reset_Label_ButtonInputs */

const en_audio_recorder_reset_label_button = /** @type {(inputs: Audio_Recorder_Reset_Label_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset recording`)
};

const fr_audio_recorder_reset_label_button = /** @type {(inputs: Audio_Recorder_Reset_Label_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réinitialiser l'enregistrement`)
};

const de_audio_recorder_reset_label_button = /** @type {(inputs: Audio_Recorder_Reset_Label_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufnahme zurücksetzen`)
};

const it_audio_recorder_reset_label_button = /** @type {(inputs: Audio_Recorder_Reset_Label_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reimposta registrazione`)
};

const ru_audio_recorder_reset_label_button = /** @type {(inputs: Audio_Recorder_Reset_Label_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сбросить запись`)
};

const es_audio_recorder_reset_label_button = /** @type {(inputs: Audio_Recorder_Reset_Label_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restablecer grabación`)
};

const zh_cn2_audio_recorder_reset_label_button = /** @type {(inputs: Audio_Recorder_Reset_Label_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重置录制`)
};

const ja_audio_recorder_reset_label_button = /** @type {(inputs: Audio_Recorder_Reset_Label_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`記録をリセット`)
};

const hi_audio_recorder_reset_label_button = /** @type {(inputs: Audio_Recorder_Reset_Label_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिकॉर्डिंग रीसेट करें`)
};

const pt_pt2_audio_recorder_reset_label_button = /** @type {(inputs: Audio_Recorder_Reset_Label_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reiniciar gravação`)
};

/**
* | output |
* | --- |
* | "Reset recording" |
*
* @param {Audio_Recorder_Reset_Label_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_reset_label_button = /** @type {((inputs?: Audio_Recorder_Reset_Label_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Reset_Label_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_reset_label_button(inputs)
	if (locale === "de") return de_audio_recorder_reset_label_button(inputs)
	if (locale === "it") return it_audio_recorder_reset_label_button(inputs)
	if (locale === "ru") return ru_audio_recorder_reset_label_button(inputs)
	if (locale === "es") return es_audio_recorder_reset_label_button(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_reset_label_button(inputs)
	if (locale === "ja") return ja_audio_recorder_reset_label_button(inputs)
	if (locale === "hi") return hi_audio_recorder_reset_label_button(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_reset_label_button(inputs)
	return en_audio_recorder_reset_label_button(inputs)
});